import { createSelector } from '@reduxjs/toolkit';

import { chatListSelector } from './chatListSelector';

export const selectCurrentRoute = createSelector(chatListSelector, chatList => chatList.currentRoute);
